import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
// import apihost from "../../services/apihostname";

//Import module Modal
import Modal from "react-bootstrap/Modal";

// Import module Services
// import AssocService from "../../services/assoc.service";
import TambonService from "../../services/tambon.service";
// import authService from "../../services/auth.service";

// Import Form
import { Form, Col, Row, FormControl } from "react-bootstrap";

//Import loading
// import LoadingAlert from "../../components/LoadingAlert";

//Import farmer.css
import "./associationModal.css";

function ModalAddAssociation(props) {
  // const [loadAlert, setLoadAlert] = useState(false);
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  // const [assoc, setAssoc] = useState([]);
  // const [data, setData] = useState([]);
  // const [ocsb, setOcsb] = useState([]);
  // const [factory, setFactory] = useState([]);
  // const [region, setRegion] = useState([]);
  const [prov, setProv] = useState([]);
  const [amp, setAmp] = useState([]);
  const [tam, setTam] = useState([]);

  const handleClose = () => {
    initialForm();
    setErrors({});
    props.hidden(false);
  };

  const getProv = () => {
    return Promise.resolve(
      TambonService.get({ pro_id: "0", amp_id: "0", tam_id: "0" })
        .then((response) => {
          setProv(response.data.data);
        })
        .catch((error) => {
          console.error("error fetching Prove: ", error);
        })
    );
  };
  useEffect(() => {
    getProv();
    setForm({});
  }, []);

  const getAmp = (prov) => {
    return new Promise(function (resolve, reject) {
      TambonService.get({
        pro_id: prov ? prov : 0,
        amp_id: 0,
        tam_id: 0,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.error("error fetching amp: ", error);
          reject(1);
        });
    });
  };
  // useEffect(async () => {
  //   await getAmp(form.assocProvince);
  // }, [form.assocProvince]);

  const handleProvChange = async (prov) => {
    setErrors({
      ...errors,
      assocProvince: null,
    });
    if (prov && prov != "") {
      await getAmp(prov).then((response) => {
        setAmp(response.data.data);
        setForm({
          ...form,
          assocProvince: prov,
          assocDistrict: "",
          assocSubdistrict: "",
        });
      });
    } else {
      setAmp([]);
      setTam([]);
      setForm({
        ...form,
        assocDistrict: "",
        assocSubdistrict: "",
      });
    }
  };

  const getTam = (prov, amp) => {
    return new Promise(function (resolve, reject) {
      TambonService.get({
        pro_id: prov ? prov : 0,
        amp_id: amp ? amp : 0,
        tam_id: 0,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.error("error fetching tam: ", error);
          reject(1);
        });
    });
  };
  // useEffect(async () => {
  //   await getTam(form.assocProvince, form.assocDistrict);
  // }, [form.assocDistrict]);

  const handleAmpChange = async (prov, amp) => {
    setErrors({
      ...errors,
      assocDistrict: null,
    });
    if (amp && amp != "") {
      await getTam(prov, amp).then((response) => {
        setTam(response.data.data);
        setForm({
          ...form,
          assocDistrict: amp,
          assocSubdistrict: "",
        });
      });
    } else {
      setTam([]);
      setForm({
        ...form,
        assocSubdistrict: "",
      });
    }
  };

  const initialForm = () => {
    setForm({});
    setErrors({});
  };

  const setField = (field, value) => {
    setForm({
      ...form,
      [field.name]: value,
    });

    if (errors[field.name])
      setErrors({
        ...errors,
        [field.name]: null,
      });
  };

  const findFormErrors = () => {
    const { assocCode, assocName } = form;
    const newErrors = {};

    // assocCode errors
    if (!assocCode || assocCode === "") newErrors.assocCode = "กรุณากรอก Code";

    // assocName errors
    if (!assocName || assocName === "") newErrors.assocName = "กรุณากรอก name";
    else if (assocName.length < 6)
      newErrors.assocName = "name ต้องมากกว่า 5 ตัว";

    // assocAddress errors
    // if (!assocAddress || assocAddress === "")
    //   newErrors.assocAddress = "กรุณากรอกยืนยัน Password";
    // else if (assocAddress != assocFax)
    //   newErrors.assocAddress = "ยืนยัน Password ไม่ถูกต้อง";

    // // comment errors
    // if (!comment || comment === "") newErrors.comment = "cannot be blank!";
    // else if (comment.length > 100) newErrors.comment = "comment is too long!";

    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = findFormErrors();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      console.log(form);
      props.onsubmit(form);
    }
  };

  return (
    <>
      <Modal size="lg" show={props.show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>เพิ่มข้อมูลสมาคม</Modal.Title>
        </Modal.Header>
        {/* {loadAlert ? <LoadingAlert /> : ""} */}
        <Modal.Body>
          {/* {JSON.stringify(props)} */}
          <Form>
            <Row>
              <Col md="3">
                <Form.Group className="mb-2">
                  <Form.Label>รหัสสมาคม</Form.Label>
                  <FormControl
                    placeholder="รหัสสมาคม"
                    type="text"
                    name="assocCode"
                    value={form.assocCode}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.assocCode}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.assocCode}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="9">
                <Form.Group className="mb-2">
                  <Form.Label>ชื่อสมาคม (ไทย)</Form.Label>
                  <FormControl
                    placeholder="ชื่อสมาคม (ไทย)"
                    name="assocName"
                    value={form.assocName}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.assocName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.assocName}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Row className="align-items-center">
              <Col md="8">
                <Form.Group className="mb-2">
                  <Form.Label>ชื่อสมาคม (อังกฤษ)</Form.Label>
                  <FormControl
                    placeholder="ชื่อสมาคม (อังกฤษ)"
                    name="assocNameeng"
                    value={form.assocNameeng}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.assocNameeng}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.assocNameeng}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="4">
                <Form.Group className="mb-2">
                  <Form.Label>ชื่อย่อ</Form.Label>
                  <FormControl
                    placeholder="ชื่อย่อ"
                    name="assocSname"
                    value={form.assocSname}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.assocSname}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.assocSname}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>ภูมิภาค</Form.Label>
                  <Form.Select
                    name="assocRegion"
                    value={form.assocRegion}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.assocRegion}
                  >
                    <option value="">เลือกภูมิภาค</option>
                    <option value="1">กลาง</option>
                    <option value="2">เหนือ</option>
                    <option value="3">ตะวันออกเฉียงเหนือ</option>
                    <option value="4">ตะวันออก</option>
                    <option value="5">ใต้</option>
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.assocRegion}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>จังหวัด</Form.Label>
                  <Form.Select
                    name="assocProvince"
                    value={form.assocProvince}
                    onChange={(e) => handleProvChange(e.target.value)}
                    isInvalid={!!errors.assocProvince}
                  >
                    <option value="">เลือกจังหวัด</option>
                    {prov.map((o) => (
                      <option key={o.value} value={o.value}>
                        {o.label}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.assocProvince}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>อำเภอ</Form.Label>
                  <Form.Select
                    name="assocDistrict"
                    value={form.assocDistrict || ""}
                    onChange={(e) =>
                      handleAmpChange(form.assocProvince, e.target.value)
                    }
                    isInvalid={!!errors.assocDistrict}
                  >
                    <option value="">เลือกอำเภอ</option>
                    {amp.map((o) => (
                      <option key={o.value} value={o.value}>
                        {o.label}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.assocDistrict}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>ตำบล</Form.Label>
                  <Form.Select
                    name="assocSubdistrict"
                    value={form.assocSubdistrict || ""}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.assocSubdistrict}
                  >
                    <option value="">เลือกตำบล</option>
                    {tam.map((o) => (
                      <option key={o.value} value={o.value}>
                        {o.label}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.assocSubdistrict}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Row className="align-items-center">
              <Col md="12">
                <Form.Group className="mb-2">
                  <Form.Label>เลขที่</Form.Label>
                  <FormControl
                    placeholder="เลขที่"
                    type="text"
                    name="assocAddress"
                    value={form.assocAddress}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.assocAddress}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.assocAddress}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Row className="align-items-center">
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>โทรศัพท์</Form.Label>
                  <FormControl
                    placeholder="โทรศัพท์"
                    name="assocPhone"
                    value={form.assocPhone}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.assocPhone}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.assocPhone}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>แฟ็กซ์</Form.Label>
                  <FormControl
                    placeholder="แฟ็กซ์"
                    name="assocFax"
                    type="text"
                    value={form.assocFax}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.assocFax}
                  />{" "}
                  <Form.Control.Feedback type="invalid">
                    {errors.assocFax}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            {/* <Button variant="primary" type="submit">
              ตกลง
            </Button>
            <Button
              variant="danger"
              onClick={() => {
                props.closeForm();
                initialForm();
              }}
            >
              ยกเลิก
            </Button> */}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-warning" onClick={handleClose}>
            ยกเลิก
          </button>
          <button
            className="btn btn-primary"
            type="submit"
            onClick={handleSubmit}
          >
            ตกลง
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalAddAssociation;

ModalAddAssociation.propTypes = {
  show: PropTypes.bool,
  hidden: PropTypes.func,
  data: PropTypes.array,
  setdata: PropTypes.func,
  onsubmit: PropTypes.func,
};
ModalAddAssociation.defaultProps = {
  data: [],
};
